import React, { FocusEvent } from "react";
import { Row, Col } from "react-bootstrap";
import { ActionHandlerFunction, CollectionServerUser } from "@preveil-api";
import { CheckboxStates, CheckboxStatesTypes, DriveUIActionTypes, useAppSelector } from "src/common";
import { Checkbox } from "src/components";
import { ListRow } from ".";
import { RootState } from "src/store/configureStore";
import _ from "lodash";

type AllProps = {
	users_list: CollectionServerUser[];
	handleAction: ActionHandlerFunction;
};

function ListViewComponent(props: AllProps) {
	const { users_list, handleAction } = props;
	const selected = useAppSelector((state: RootState) => state.admin.selected);

	// Description: Get the selected all checkbox state
	function getSelectedState(): CheckboxStatesTypes {
		let ck_state: CheckboxStatesTypes = CheckboxStates.empty;
		ck_state = !selected.length
			? CheckboxStates.empty
			: selected.length < users_list.length
				? CheckboxStates.indeterminate
				: CheckboxStates.checked;
		return ck_state;
	}

	// Description: Render the rows of Admin Users view
	function RenderList(_list: CollectionServerUser[]) {
		return (
			<div className="list-body">
				{_.map(_list, (_user: CollectionServerUser, i: number) => {
					return (
						<ListRow
							key={`item_${i}`}
							user={_user}
							handleAction={handleAction}
							selected={selected.includes(_user.user_id)}
						/>
					);
				})}
			</div>
		);
	}

	return (
		<div className="admin-list-view compact">
			{!!users_list && users_list.length > 0 && (
				<Row className="header-row">
					<Col md="1">
						<Checkbox
							className="sr-only"
							onChange={(e: FocusEvent<HTMLInputElement>) => {
								handleAction({
									actionType: DriveUIActionTypes.Select,
									params: { selected: e.target.checked },
								});
							}}
							value="all"
							label="Select All"
							selected={getSelectedState()}
						/>
					</Col>
					<Col md="3" className="col">Name</Col>
					<Col md="3">Email</Col>
					<Col md="3">Department</Col>
				</Row>
			)}
			{RenderList(users_list)}
		</div>
	);
}

export default React.memo(ListViewComponent);
